import fs from 'node:fs'
import path from 'node:path'
import { MAIN_CSS_CANDIDATES } from '@cli-constants/scaffolding.js'
export function findMainCss(cwd: string): string | undefined {
  for (const candidate of MAIN_CSS_CANDIDATES) {
    const filePath = path.join(cwd, candidate)
    if (fs.existsSync(filePath)) return filePath
  }
  return undefined
}
